<template>
  <div class="login_info_box">
    <div v-show="!moreAccount">
      <div class="login_info_box_item">
        <div>{{ $t('login.phone_number') }}</div>
        <div>
          <el-input ref="phone_input" :placeholder="$t('login.enter_phone_number')"
            v-model="loginForm.phoneNumber"></el-input>
        </div>
      </div>
      <div class="login_info_box_item">
        <div>{{ $t('login.verify') }}</div>
        <div>
          <el-input :placeholder="$t('login.enter_verify')" v-model="loginForm.verifyCode">
            <template slot="append">
              <span style="cursor: pointer;user-select: none;color: #1e50f0;" @click="getverifyCode">{{ msg }}</span>
            </template>
          </el-input>
        </div>
      </div>
      <div class="login_info_box_item">
        <b2b-button @click="login">{{ $t('login.login_btn') }}</b2b-button>
      </div>
    </div>
    <div v-show="moreAccount">
      <p style="font-size: 16px;margin-bottom: 15px;">请选择登录账号</p>
      <div class="account_item" v-for="item in accounts" :key="item.partnerCode"
        :class="item.partnerCode == selAccount.partnerCode ? 'active' : ''" @click="clickAccount(item)">
        <img src="../../../../assets/newImage/sel_per.png" style="width: 18px;height: 18px;" alt=""
          v-if="selAccount.partnerCode == item.partnerCode">
        <img src="../../../../assets/newImage/not_sel.png" style="width: 18px;height: 18px;" alt="" v-else>
        {{ item.companyName }}({{ item.partnerCode }})
      </div>
      <div class="login_info_box_item">
        <b2b-button @click="toHome">立即进入</b2b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      seconds: 60,
      isClick: false,
      loginForm: {
        device: 'from b2b'
      },
      moreAccount: false,
      accounts: [],
      selAccount: {}
    }
  },
  methods: {
    getverifyCode () {
      if (!this.loginForm.phoneNumber) {
        this.$refs.phone_input.focus()
        return this.$message.warning('请输入手机号码!')
      }
      let phoneTest = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
      if (!phoneTest.test(this.loginForm.phoneNumber)) return this.$message.warning('请输入正确的手机号码')
      if (!this.isClick) {
        this.isClick = true;
        // 发送验证码
        this.getVerifyCode()
        let time = setInterval(() => {
          if (this.seconds > 1) {
            this.seconds--;
          } else {
            this.isClick = false;
            this.seconds = 60;
            clearInterval(time)
          }
        }, 1000)
      }
    },
    async getVerifyCode () {
      const { data: result } = await this.$http.get(`mini/verifyCode?phoneNumber=${this.loginForm.phoneNumber}`)
      if (result.code != 200) this.$message.error(result.message)
    },
    async login () {
      const { data: result } = await this.$http.post('mini/loginBySecretCode', this.loginForm)
      if (result.code != 200) return this.$message.error(result.message)
      if (result.data && result.data.length == 1) {
        localStorage.setItem('partnerInfo', JSON.stringify(result.data[0]))
        sessionStorage.removeItem('homeSearchForm')
        this.$router.push('/NewHome')
      } else {
        this.accounts = result.data
        this.moreAccount = true
      }
    },
    clickAccount (item) {
      this.selAccount = item
    },
    toHome () {
      localStorage.setItem('partnerInfo', JSON.stringify(this.selAccount))
      sessionStorage.removeItem('homeSearchForm')
      this.$router.push('/NewHome')
    }
  },
  computed: {
    msg () {
      return this.isClick ? `${this.seconds}s` : this.$t('login.get_verify')
    }
  }
}
</script>

<style lang="less" scoped>
.login_info_box {
  font-size: 14px;
  font-family: '苹方';

  .login_info_box_item {
    display: grid;
    grid-auto-rows: auto auto;
    grid-row-gap: 10px;
    margin-bottom: 30px;
  }

  /deep/ .el-input-group__append {
    background-color: #fff;
  }

  .account_item {
    padding: 10px 15px;
    border: 1px solid #e8e8e8;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    column-gap: 10px;
    cursor: pointer;
    border-radius: 4px;

    &.active {
      border-color: #1e50f0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/login/components/LoginByVerifyCode.vue